import { Asset, Location } from '@models';
import { Point } from 'ngx-panzoom/lib/types/point';

export const isAsset = (item: Asset | Location): item is Asset =>
  (item as Location).parentLocationId === undefined;

export const isPoint = (
  item: Asset | Location | Point | undefined
): item is Point =>
  !!item && (item as Point).x !== undefined && (item as Point).y !== undefined;
